var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4855_27431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 250,
    height: 160,
    rx: 8,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4855_27431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 29,
    width: 110,
    height: 82,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 30,
    width: 108,
    height: 80,
    rx: 3,
    stroke: "#D8D8D8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 62,
    width: 61,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 71,
    width: 41,
    height: 5,
    rx: 2.5,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4855_27431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 29,
    width: 110,
    height: 82,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 30,
    width: 108,
    height: 80,
    rx: 3,
    stroke: "#D8D8D8",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 61.6387,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.598,
    y: 61.6387,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.195,
    y: 61.6387,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.793,
    y: 61.6387,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 77.4941,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.598,
    y: 77.4941,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.195,
    y: 77.4941,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.793,
    y: 77.4941,
    width: 13.2,
    height: 13.4178,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 47,
    width: 60,
    height: 3.65939,
    rx: 1.82969,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 53.0996,
    width: 60,
    height: 3.65939,
    rx: 1.82969,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4855_27431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 24,
    width: 124,
    height: 92,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 25,
    width: 122,
    height: 90,
    rx: 3,
    stroke: "#2990FB",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 41.7598,
    width: 60.9898,
    height: 41.4731,
    rx: 4,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 88.1094,
    width: 60.9898,
    height: 3.65939,
    rx: 1.82969,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 94.209,
    width: 60.9898,
    height: 3.65939,
    rx: 1.82969,
    fill: "#F2F3F7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 132,
    width: 28,
    height: 12,
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 132H183C185.209 132 187 133.791 187 136V140C187 142.209 185.209 144 183 144H175V132Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 132H137C134.791 132 133 133.791 133 136V140C133 142.209 134.791 144 137 144H145V132Z",
    fill: "#2990FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180 141L183 138L180 135",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 141L137 138L140 135",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4855_27431",
    x: -5,
    y: 13,
    width: 150,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_27431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4855_27431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4855_27431",
    x: 175,
    y: 13,
    width: 150,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_27431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4855_27431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4855_27431",
    x: 78,
    y: 8,
    width: 164,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4855_27431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4855_27431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4855_27431"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentations);
export default __webpack_public_path__ + "static/media/presentations.91bc9b5efa0ff739e2c5feae21eb4863.svg";
export { ForwardRef as ReactComponent };